import React, { createRef } from 'react'
import './index.scss'
import legoService from '../../services/lego'
import { withRouter, RouteProps } from 'react-router-dom'
import { resetTree } from '../../store/actions'
import { connect } from 'react-redux'
import { KeyOutlined, PlusOutlined, SearchOutlined, UserOutlined } from '@ant-design/icons'
import { Popconfirm, Spin, Button, message, Input, DatePicker, Table, Form, Space } from 'antd'
import { ColumnProps } from 'antd/es/table'
import bxlutils from 'bxl-utils'
import moment from 'moment'
import { withTranslation } from 'react-i18next'
const { RangePicker } = DatePicker

const getDataByFormData = data => {
  if (!data) {
    return
  }
  return Object.entries(data).reduce((init, [key, value]) => {
    if (value) {
      if (key === 'createdRange') {
        init['created_at_from'] = moment((value as Date[])[0]).valueOf()
        init['created_at_end'] = moment((value as Date[])[1]).valueOf()
      } else if (key === 'modifiedRange') {
        init['last_modified_from'] = moment((value as Date[])[0]).valueOf()
        init['last_modified_end'] = moment((value as Date[])[1]).valueOf()
      } else {
        init[key] = value
      }
    }
    return init
  }, {})
}

const getFormDataByData = data => {
  if (!data) {
    return data
  }
  const fromData = {
    keyword: data.keyword || '',
    author: data.author || '',
  }
  if (data.created_at_from && data.created_at_end) {
    fromData['createdRange'] = [moment(data.created_at_from), moment(data.created_at_end)]
  }
  if (data.last_modified_from && data.last_modified_end) {
    fromData['modifiedRange'] = [moment(data.last_modified_from), moment(data.last_modified_end)]
  }
  return fromData
}
const pageListCondition = () => JSON.parse(localStorage.getItem('pageListCondition') || '{}')
interface Istate {
  pageNum: number
  list: any[]
  total: number
  spinning: boolean
  condition: {
    keyword?: string
    created_at_from?: number
    created_at_end?: number
    author?: string
  }
}
const initialState = {
  pageNum: 1,
  list: [],
  total: 1000,
  spinning: false,
  condition: pageListCondition(),
}

const mapDispatchToProps = dispatch => ({
  resetState: () => {
    dispatch(resetTree())
  },
})

const copyLink = (link, item) => {
  const eqlink = bxlutils.uri.stringify({
    utm_source: item.utm_source,
    utm_medium: item.utm_medium,
    utm_campaign: item.utm_campaign,
    utm_term: item.utm_term,
    utm_content: item.utm_content,
  })
  link = link + '?' + eqlink
  const input = document.createElement('input')
  document.body.appendChild(input)
  input.setAttribute('value', link)
  input.select()
  if (document.execCommand('copy')) {
    document.execCommand('copy')
    message.success('Success! ' + link, 2)
  }
  document.body.removeChild(input)
}
const getSourceLink = (link, item) => {
  const eqlink = bxlutils.uri.stringify({
    utm_source: item.utm_source,
    utm_medium: item.utm_medium,
    utm_campaign: item.utm_campaign,
    utm_term: item.utm_term,
    utm_content: item.utm_content,
  })
  return link + '?' + eqlink
}
interface adItem {
  utm_term?: string
  utm_medium?: string
  utm_source?: string
  utm_content?: string
  utm_campaign?: string
}
// interface sourceItem {
//   ad_tags: adItem[]
// }
const sourceContent = (item: any) => {
  if (!item['meta']['ad_tags']) return null
  return (
    <div className="sourcecontent">
      {item['meta']['ad_tags'].map((ele: adItem, index: Number) => {
        return (
          <div className="sourceItem" key={`tagItem${index}`}>
            <p className="title">source: {ele.utm_source}</p>{' '}
            <a
              className="sourcelink"
              href="javascript:void(0)"
              onClick={() => copyLink(item.link, ele)}
            >
              {getSourceLink(item.link, ele)}
            </a>
          </div>
        )
      })}
    </div>
  )
}

class PageList extends React.Component<RouteProps & any, Istate> {
  state: Istate = initialState
  formInstance = createRef<any>()
  componentDidMount() {
    this.getList()
    this.formInstance.current.setFieldsValue(getFormDataByData(pageListCondition()))
  }

  getList = () => {
    this.setState({
      spinning: true,
    })
    const from = (this.state.pageNum - 1) * 10
    const to = this.state.pageNum * 10
    const filter = pageListCondition() || {}
    delete filter.bucket
    legoService
      .getWebSitesList(from, to, filter)
      .then(res => {
        this.setState({
          list: this.formateTableData(res.data.pages),
          total: +res.data.total,
          spinning: false,
        })
      })
      .catch(err => {
        this.setState({
          spinning: false,
        })
        console.error(err)
      })
  }

  copyLink = (link: string, item) => {
    if (item.meta?.channel) {
      message.warning('请复制带有标识的链接,便于数据追踪', 2)
      return
    }
    const input = document.createElement('input')
    document.body.appendChild(input)
    input.setAttribute('value', link)
    input.select()
    if (document.execCommand('copy')) {
      document.execCommand('copy')
      message.success(this.props.t('copySuccess') + ': ' + link, 2)
    }
    document.body.removeChild(input)
  }

  deleteWeb(id: string) {
    legoService
      .deleteWebsite(id)
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .then(res => {
        message.success(this.props.t('deleteSuccess'))
        this.getList()
      })
      .catch(err => {
        console.log(err)
        message.error(err.message || err)
      })
  }

  getDate(timeStamp) {
    if (timeStamp === -1) {
      return '--'
    }
    const date = new Date(timeStamp)
    const year = date.getFullYear()
    let month: string | number = date.getMonth() + 1
    month = month < 10 ? '0' + month : month
    let day: string | number = date.getDate()
    day = day < 10 ? '0' + day : day
    return !timeStamp || !date ? '未发布' : `${year}-${month}-${day}`
  }

  addWeb = () => {
    this.props.resetState()
    this.props.history.push(`/lego/edit`)
  }

  toEdit = id => {
    this.props.history.push({
      pathname: `/lego/edit/${id}`,
    })
  }
  publish = pageId => {
    const hide = message.loading(this.props.t('publishing'), 0)
    legoService
      .publishWebInfo(pageId, {
        bucket: 'baleen',
      })
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .then(res => {
        this.getList()
        message.success(this.props.t('publishSuccess'))
        hide()
      })
      .catch(err => {
        if (err && err.message) {
          message.error(err.message)
        }
        hide()
        console.log(err)
      })
  }
  copyItem = id => {
    this.props.history.push({
      pathname: '/lego/edit',
      state: {
        id: id,
      },
    })
  }

  changePageNum = (num: number) => {
    this.setState(
      {
        pageNum: num,
      },
      () => {
        this.getList()
      }
    )
  }

  handleSubmit = data => {
    localStorage.setItem('pageListCondition', JSON.stringify(getDataByFormData(data)))
    this.setState(
      {
        pageNum: 1,
        condition: getDataByFormData(data) || {},
      },
      () => {
        this.getList()
      }
    )
  }

  formateTableData = list => {
    const { pageNum } = this.state
    return list
      ? list.map((item: any, index) => {
          const dogfoodLink = item.dogfood_link
          return {
            key: index,
            num: index + 1 + (pageNum - 1) * 10,
            actions: {
              edit: () => this.toEdit(item.page_id),
              publish: () => this.publish(item.page_id),
              copy: () => this.copyItem(item.page_id),
              delete: (e: any) => {
                e.stopPropagation()
                this.deleteWeb(item.page_id)
              },
            },
            ...item,
            linkAction: {
              value: item.link,
              dogfood_Link: dogfoodLink,
              copyDogFoodLink: () => this.copyLink(dogfoodLink, item),
              copyLink: () => this.copyLink(item.link, item),
            },
            created_at: item.created_at > 0 ? this.getDate(item.created_at) : '-',
            last_modified_at: item.last_modified_at > 0 ? this.getDate(item.last_modified_at) : '-',
            id: item.id,
          }
        })
      : []
  }

  getColumns = (): ColumnProps<any>[] => {
    const t = this.props.t
    return [
      {
        title: t('serialNumber'),
        dataIndex: 'num',
        key: 'num',
        width: 60,
        align: 'center',
      },
      {
        title: 'ID',
        dataIndex: 'page_id',
        key: 'page_id',
        width: 300,
        align: 'center',
      },
      {
        title: t('title'),
        width: 200,
        dataIndex: 'title',
        key: 'title',
        ellipsis: true,
        align: 'center',
      },
      {
        title: t('link'),
        dataIndex: 'linkAction',
        key: 'linkAction',
        width: 280,
        align: 'center',
        render: linkAction => {
          return linkAction ? (
            <span>
              <Button
                size="small"
                onClick={linkAction.copyLink}
                type="primary"
                disabled={!linkAction.value}
              >
                copy production link
              </Button>
              <Button
                disabled={!linkAction.dogfood_Link}
                size="small"
                onClick={linkAction.copyDogFoodLink}
                type="primary"
              >
                copy dogFood link
              </Button>
            </span>
          ) : (
            <span>无</span>
          )
        },
      },
      {
        title: t('generatedTime'),
        dataIndex: 'created_at',
        key: 'created_at',
        width: 120,
        align: 'center',
      },
      {
        title: t('lastEdited'),
        dataIndex: 'last_modified_at',
        key: 'last_modified_at',
        width: 120,
        align: 'center',
      },
      {
        title: t('author'),
        dataIndex: 'author',
        key: 'author',
        width: 120,
        align: 'center',
      },
      {
        title: t('action'),
        dataIndex: 'actions',
        key: 'actions',
        width: 200,
        align: 'center',
        render: (actions, record) => (
          <span>
            <a
              className="actionBtn"
              onClick={actions && actions.edit}
              href={window.location.href.replace(
                window.location.hash,
                `#/lego/edit/${record.page_id}`
              )}
            >
              {t('edit')}
            </a>
            <span className="actionBtn" onClick={actions && actions.copy}>
              {t('copy')}
            </span>
            <Popconfirm
              placement="left"
              title={`确认删除 ${record.page_id} ？`}
              onConfirm={actions && actions.delete}
              okText="Yes"
              cancelText="No"
            >
              <span className="actionBtn">{t('delete')}</span>
            </Popconfirm>
            <span className="actionBtn" onClick={actions && actions.publish}>
              {t('release')}
            </span>
          </span>
        ),
      },
    ]
  }
  render() {
    const { pageNum, list, total, spinning } = this.state
    return (
      <div className="page-list-wrapper">
        <Spin tip="Loading..." size="large" spinning={spinning}>
          <Space direction="vertical" style={{ width: '100%' }} size={30}>
            <Form
              layout="inline"
              style={{ padding: 15, background: '#fff' }}
              onFinish={this.handleSubmit}
              ref={this.formInstance}
            >
              <Form.Item name="keyword">
                <Input
                  prefix={<KeyOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                  placeholder={this.props.t('titleKeywordsOrId')}
                  allowClear
                />
              </Form.Item>
              <Form.Item name="author">
                <Input
                  prefix={<UserOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                  placeholder={this.props.t('author')}
                  allowClear
                />
              </Form.Item>
              <Form.Item name="createdRange">
                <RangePicker allowClear placeholder={['Created from', 'Created to']} />
              </Form.Item>
              <Form.Item name="modifiedRange">
                <RangePicker allowClear placeholder={['Modified from', 'Modified to"']} />
              </Form.Item>
              <Form.Item>
                <Button icon={<SearchOutlined />} type="primary" htmlType="submit">
                  {this.props.t('search')}
                </Button>
              </Form.Item>
              <Form.Item>
                <Button htmlType="reset">{this.props.t('reset')}</Button>
              </Form.Item>
            </Form>
            <Table
              columns={this.getColumns()}
              size="middle"
              expandedRowRender={record => sourceContent(record)}
              expandRowByClick={true}
              expandable={{
                expandedRowRender: record => sourceContent(record),
                rowExpandable: record => record.meta && record.meta.ad_tags,
                expandRowByClick: true,
                defaultExpandAllRows: true,
              }}
              dataSource={list}
              rowKey="id"
              pagination={{
                current: pageNum,
                total: total,
                onChange: this.changePageNum,
                showQuickJumper: true,
              }}
              bordered
              scroll={{ x: 1500 }}
            />
          </Space>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            id="newScene"
            onClick={() => {
              this.addWeb()
            }}
          ></Button>
        </Spin>
      </div>
    )
  }
}

export default connect(null, mapDispatchToProps)(withTranslation()(withRouter(PageList)))
